import { Button, Checkbox, CheckboxGroup, IconButton, Stack, Switch, Text } from '@chakra-ui/react';
import { SelectOption } from '@pelicargo/types';
import { useCallback } from 'react';
import { HiChevronLeft } from 'react-icons/hi';

import { QuoteFilters } from '.';

const sortByName = (a: SelectOption, b: SelectOption) => a?.label?.localeCompare(b?.label);

type Props = {
  filters: QuoteFilters;
  providers?: SelectOption[];
  handleFilterChange: (key: string) => (nextValue: boolean | string[]) => void;
  resetView: () => void;
};

export const AirlineFilter = ({ filters, providers = [], handleFilterChange, resetView }: Props) => {
  const handleAirlinesChange = (providers: string[]) => {
    handleFilterChange('providers')(providers as string[]);
  };

  const toggleAllAirlines = useCallback(() => {
    if (filters?.providers?.length === providers?.length) {
      handleAirlinesChange([]);
    } else {
      handleAirlinesChange(providers.map((provider) => provider.value));
    }
  }, [filters.providers, providers, handleFilterChange]);

  const toggleGroupByAirline = useCallback(() => {
    handleFilterChange('groupByProvider')(!filters.groupByProvider);
  }, [handleFilterChange, filters.groupByProvider]);

  return (
    <Stack spacing="2" pt="2">
      <Stack direction="row" align="center" spacing="2">
        <IconButton
          aria-label="Go back"
          icon={<HiChevronLeft />}
          variant="link"
          size="sm"
          display={{ base: 'flex', md: 'none' }}
          minW="auto"
          onClick={resetView}
        />
        <Text textStyle="label">Airlines</Text>
      </Stack>
      <Stack direction="row" align="center" justify="space-between" w="full" borderBottomWidth={1} pb={2}>
        <Text>Only show best option per airline</Text>
        <Switch size="sm" isChecked={filters?.groupByProvider} onChange={toggleGroupByAirline} />
      </Stack>
      <Stack direction="row" align="center" justify="space-between" w="full">
        <Text>Select all providers</Text>
        <Switch size="sm" isChecked={filters?.providers?.length === providers?.length} onChange={toggleAllAirlines} />
      </Stack>
      <Stack>
        <CheckboxGroup value={filters.providers} onChange={handleAirlinesChange}>
          {providers?.sort(sortByName)?.map((provider) => (
            <Stack key={provider?.value} direction="row" justify="space-between" role="group">
              <Checkbox value={provider?.value}>{provider?.label}</Checkbox>
              <Button
                size="xs"
                opacity={0}
                _groupHover={{ opacity: 1 }}
                onClick={() => handleAirlinesChange([provider.value])}
              >
                Only
              </Button>
            </Stack>
          ))}
        </CheckboxGroup>
      </Stack>
    </Stack>
  );
};
